const geoLocationMixin = {
    data() {
        return {

        }
    },
    methods: {
        fetchUserLocation (timeout = 15000) {
            return new Promise(function(resolve, reject) {
                let options = {
                    enableHighAccuracy: true,
                    timeout: timeout,
                    maximumAge: 0
                };
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        console.log("Доступ разрешён.");
                        resolve(position)
                    },
                    function (error) {
                        if(error.code == 1) {
                            console.log(`В доступе отказано! error.code: ${error.code}`);
                        }
                        reject(error)
                    },
                    options
                )
            })
        },
    }
}
export default geoLocationMixin